import { render, staticRenderFns } from "./DeleteIncidentModal.vue?vue&type=template&id=b3562382&"
import script from "./DeleteIncidentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteIncidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports